<template>
    <div id="servers-container">
        <div style="margin-bottom: 10px;">
            <h1>Servers</h1>
            <p>OFB serves over <b>1,000,000</b> users across <b>10,000+</b> servers. Check out a few of them below!</p>
        </div>

        <h2>Sponsored Servers</h2>
        <div class="sp-servers-container" v-if="!userIsDesktop">
            <SaphServer
                    v-for="saphSponsor in saphSponsors"
                    :key="saphSponsor.key"
                    :title="saphSponsor.name"
                    :description="saphSponsor.longDesc"
                    :image="saphSponsor.imagePath"
                    b-type="discord"
                    :url="saphSponsor.discordURL"
            />

            <GoldServer
                    v-for="(goldSponsor, index) in goldSponsors"
                    :key="index"
                    :title="goldSponsor.name"
                    :image="goldSponsor.imagePath"
                    :description="goldSponsor.longDesc"
                    :url="goldSponsor.discordURL"

            />

            <IronServer
                    v-for="(ironSponsor) in ironSponsors"
                    :key="ironSponsor.key"
                    :title="ironSponsor.name"
                    :image="ironSponsor.imagePath"
                    :url="ironSponsor.discordURL"
            />

        </div>

        <div v-else class="sp-servers-container">

            <div class="sp-desktop-col">
                <SaphServer
                        v-for="saphSponsor in saphSponsors"
                        :key="saphSponsor.key"

                        :title="saphSponsor.name"
                        :description="saphSponsor.longDesc"
                        :image="saphSponsor.imagePath"
                        :url="saphSponsor.discordURL"
                        b-type="discord"
                />

                <IronServer
                        :title="ironSponsors[0].name"
                        :image="ironSponsors[0].imagePath"
                        :url="ironSponsors[0].discordURL"
                />
            </div>

            <div class="sp-desktop-col">
                <GoldServer
                        v-for="goldSponsor in goldSponsors"
                        :key="goldSponsor.key"

                        :title="goldSponsor.name"
                        :image="goldSponsor.imagePath"
                        :description="goldSponsor.longDesc"
                        :url="goldSponsor.discordURL"
                />

                <IronServer
                        :title="ironSponsors[1].name"
                        :image="ironSponsors[1].imagePath"
                        :url="ironSponsors[1].discordURL"
                />
            </div>
        </div>

        <h3 style="margin-bottom: 1rem;">All Servers</h3>
        <v-data-table
                :headers="headers"
                :items="servers"
                :items-per-page="5"
                mobile-breakpoint="0"
                id="servers-table"
        ></v-data-table>
    </div>
</template>


<script>
import SaphServer from './sub-components/SaphServer'
import GoldServer from "./sub-components/GoldServer";
import IronServer from "./sub-components/IronServer";
import ServerList from "../serverlist.json"
import SPONSORS from '../utils/Sponsors'

const numSaphSponsors = 1
const numGoldSponsors = 1
const numIronSponsors = 2

export default {
    name: 'Servers',

    created() {
        this.userIsDesktop = window.matchMedia('(min-width: 1000px)').matches
        window.addEventListener("resize", this.handleResize)

        this.setNewSponsors()
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize)
    },

    mounted() {
        window.scrollTo(0,0)
        this.setNewSponsors()
    },

    components: {
        IronServer,
        GoldServer,
        SaphServer
    },

    data: () => ({
        userIsDesktop: false,

        saphSponsors: [],
        goldSponsors: [],
        ironSponsors: [],

        headers: [
            {
                text: 'Server Name',
                align: 'start',
                sortable: false,
                value: 'name',
            },

            {
                text: 'User Count',
                align: 'end',
                sortable: false,
                value: 'members',
            },
        ],
        servers: ServerList
    }),

    methods: {
        handleResize: function () {
            this.userIsDesktop = window.matchMedia('(min-width: 1000px)').matches
        },

        setNewSponsors: function () {
            this.saphSponsors = SPONSORS.random(SPONSORS.tiers.saph, numSaphSponsors)
            this.goldSponsors = SPONSORS.random(SPONSORS.tiers.gold, numGoldSponsors)
            this.ironSponsors = SPONSORS.random(SPONSORS.tiers.iron, numIronSponsors)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    h1 {
        align-self: flex-start;
        margin-bottom: 5px;
    }

    h2 {
        margin-bottom: 1rem;
    }

    p {
        font-size: 18px;
        color: #C2C2C2;
    }

    #servers-container {
        height: auto;
        padding: 20px 20px 10px 20px;
        background-color: #292929;
    }

    .sp-servers-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        margin-bottom: 2rem;
    }

    #servers-table {
        background-color: #404040;
        box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
    }

    @media screen and (min-width: 1000px) {
        #servers-container {
            width: 50%;
            max-width: 1000px;
            margin: auto;
        }

        .sp-servers-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
        }

        .sp-desktop-col {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            height: auto;
            width: 49%;
        }
    }

</style>
